
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class PluDtGrid extends Serenity.EntityGrid<PluDtRow, any> {
        protected getColumnsKey() { return PluDtColumns.columnsKey; }
        protected getDialogType() { return PluDtDialog; }
        protected getEditorType() { return PluDtEditor; }
        protected getIdProperty() { return PluDtRow.idProperty; }
        protected getInsertPermission() { return PluDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PluDtRow.localTextPrefix; }
        protected getService() { return PluDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            var q = Q.parseQueryString();
            if (q["SkuCode"]) {
                var category = Q.tryFirst(filters, x => x.field == "SkuCode");
                category.init = e => {
                    e.element.getWidget(Serenity.LookupEditor).value = q["SkuCode"];
                };
            }


            return filters;
        }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected beforeLoadEntity() {
            let self = this;            

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }
        protected getButtons() {
            var buttons = super.getButtons();
            

            // Add buttons export excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PluDtService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
            
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "Id", title: "ID", cellWidth: 5, halign: 'left' },
                1: { field: "SkuCode", title: "รหัสสต๊อก", cellWidth: 30, halign: 'left' },
                2: { field: "PluCode", title: "รหัสขาย", cellWidth: 30, halign: 'left' },
                3: { field: "PluDesc", title: "ชื่อสินค้า", cellWidth: 30, halign: 'left' },
            }    
            
            return buttons;
        }
    }
}